import { render, staticRenderFns } from "./FullAudioPlayer.vue?vue&type=template&id=ac1872a8&"
import script from "./FullAudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./FullAudioPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports